module.exports = {
  title: 'Blurred Scroll with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-10-25',
  slug: 'blurred-scroll',
  tags: ['skia', 'reanimated'],
};
